export default __webpack_public_path__ + "static/media/PastiPas.aa69eb96.png";